import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class BatchSessionUpdateModel extends BaseModel {
  auction_date_uuid = null;

  rules = {
    auction_date_uuid: 'required'
  };

  attributeLabels = {
    auction_date_uuid: i18n.t('Session'),
  };

  attributeHints = {};

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
